<template>
  <div class="mainWrap">
    <div class="tutorial_main">
      <div class="nav_filter_wrap">
        <div class="up_wrap">
          <div class="icon" @click="goBack">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
          <div class="main_wrap">
            <div class="left">
              <p>FIFA/CFA讲师教案</p>
            </div>
            <div class="right">
              <div class="zuxie-btn" @click="createTutorial('practice')">创建FIFA/CFA讲师教案</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="mainHeader">
          <div class="tips">
            <p>全部教案</p>
          </div>
          <div class="searchWrap">
            <div class="wrap">
              <input
                type="text"
                v-model.lazy.trim="req_data.search_keywords"
                @keyup.enter="search"
                placeholder="输入您想要查找的教案内容"
              >
              <div v-show="req_data.search_keywords!=''" class="close" @click="hideIcon">
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="search" @click="search">搜索</div>
          </div>
        </div>
        <template v-if="showList">
          <div class="mainBody">
            <vue-scroll :ops="ops" ref="vs">
              <div class="contentWrap">
                <div class="content">
                  <div
                    class="tutorialItem"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="lookOverDetail(item.plan_id)"
                  >
                    <div class="up">
                      <div class="imgWrap">
                        <img :src="item.drill_id | addSrc(item.last_updated)" alt @error="imgTutorialErr($event)">
                        <span v-if="item.is_owner" @click.stop="downloadPDF(item.plan_id)" class="load_btn"><v-icon
                          class='svg' name="file-pdf" scale="1.1"></v-icon>
                        <span class="down_text">下载/打印</span>
                        </span>
                        <tutorial-type :excellent="item.is_excellent" :type="item.session_type"></tutorial-type>
                        <tutorial-excellent v-if="Number(item.is_excellent) === 1"></tutorial-excellent>
                      </div>
                      <div class="title">
                        <p>{{item.title}}</p>
                        <p class="author">作者：{{item.user_name}}</p>
                      </div>
                    </div>
                    <div class="down">
                      <!-- <p class="author">作者：{{item.user_name}}</p> -->
                      <!-- <p class="updateTime">更新：{{item.last_updated | time}}</p> -->
                      <!--                                            <p class="club_name">{{item.class_name}}</p>-->
                      <p class="club_name">最后更新时间：{{item.last_updated | time(false)}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div id="paging">
            <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
          </div>
        </template>
        <yioks-empty v-show="showEmpty" :h="'500px'"></yioks-empty>
      </div>
    </div>
  </div>
</template>

<script>
  import "vue-awesome/icons/file-pdf";
  import tutorialMixin from "@/minix/tutorial_teacher";
  import {myTutorial, downloadTutorial} from "@/api/training_student/api";
  import commonFun from "@/assets/js/yioks";
  import fiveMixins from '@/minix/fiveMixins';

  const {downfile} = commonFun;
  import {isEvaluated} from "@/api/training_student/api";

  export default {
    name: "tutorial-person",
    mixins: [tutorialMixin, fiveMixins],
    data() {
      return {
        downPdfFlag: false,
      };
    },
    components: {
      "yioks-status": () => import("@/components/Tips/Status"),
    },
    created() {
      // this.isEvaled();
    },
    methods: {
      downloadPDF(plan_id) {
        if (this.downPdfFlag) return;
        this.downPdfFlag = true;
        downloadTutorial({plan_id})
          .then(({data}) => {
            if (Number(data.status) === 0) {
              downfile(data.result.pdf_url);
            }
            this.downPdfFlag = false;
          })
          .catch(err => {
            this.downPdfFlag = false;
            console.error(err);
          });
      },
      goBack() {
        // this.$router.go(-1);
        this.$router.push({
          path: "class_detail",
          query: {}
        });
      },
      handleRequest() {
        this.reqMyList();
      },
      reqMyList() {
        myTutorial({...this.req_data, page: this.page})
          .then(res => {
            // console.log(res);
            this.handleData(res.data);
          })
          .catch(err => {
            console.error(err);
          });
      },
      createTutorial(type) {
        //              let url =window.location.origin //这是当前窗口
        const ua = navigator.userAgent;
        const userInfo = this.$store.state.userInfo;
        const userType = this.isFive ? 'five' : 'eleven';
        window.location.href = `/static/session_editor/sspeditor.html?practice=${type}&uid=${userInfo.uid}&member_type=${userInfo.member_type}&class_level=${userInfo.class_level}&sessionCategoryId=52&userType=${userType}`
        // if (ua.indexOf("Chrome") > -1) {
        //   if (window.top !== window) {
        //     let _protocol = window.location.protocol;
        //     if(_protocol.indexOf(":") == -1)_protocol=_protocol+":";
        //     window.top.location.href = _protocol + "//" + window.location.host + `/teacher/create_tutorial?session_type=${type}&sessionCategoryId=52`
        //     //
        //   } else {
        //     this.$router.push({
        //       path: 'create_tutorial',
        //       query: {
        //         session_type: type,
        //         sessionCategoryId: '52'
        //       }
        //     });
        //   }
        // } else {
        //   this.$router.push({
        //     path: 'create_tutorial',
        //     query: {
        //       session_type: type,
        //       sessionCategoryId: '52'
        //     }
        //   });
        // }
      },
      gotoSetting() {
        if (this.tips.show_type === 'eva_show') {
          this.$router.push({name: 'StuCreateEvaluation'});
        }
      }
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/tutorial-person'
  @import "~@/assets/css/nav_filter";
  .eval-dialog
    .to-eval
      font-size 16px
      text-align center
      img
        width 100px
      .tips
        margin-bottom 15px

  .nav_filter_wrap
    .up_wrap
      border-bottom none
      padding: 10px 0 10px;
</style>
